// 渐变色配置
export const GRADIENT_LIST = [
  {
    id: "blue",
    name: "dbl_chart_condition_color_blue",
    color: [
      {
        hexa: "#E6EDFC",
        alpha: "100"
      },
      {
        hexa: "#B4C9F6",
        alpha: "100"
      },
      {
        hexa: "#81A5EF",
        alpha: "100"
      },
      {
        hexa: "#4F81E8",
        alpha: "100"
      },
      {
        hexa: "#034BDE",
        alpha: "100"
      }
    ]
  },
  {
    id: "green",
    name: "dbl_chart_condition_color_green",
    color: [
      {
        hexa: "#E7F1EF",
        alpha: "100"
      },
      {
        hexa: "#B6D4CE",
        alpha: "100"
      },
      {
        hexa: "#85B7AD",
        alpha: "100"
      },
      {
        hexa: "#549A8C",
        alpha: "100"
      },
      {
        hexa: "#0A6E5A",
        alpha: "100"
      }
    ]
  },
  {
    id: "yellow",
    name: "dbl_chart_condition_color_yellow",
    color: [
      {
        hexa: "#FAF2E6",
        alpha: "100"
      },
      {
        hexa: "#EED7B4",
        alpha: "100"
      },
      {
        hexa: "#E2BC81",
        alpha: "100"
      },
      {
        hexa: "#D6A24F",
        alpha: "100"
      },
      {
        hexa: "#C47903",
        alpha: "100"
      }
    ]
  },
  {
    id: "red",
    name: "dbl_chart_condition_color_red",
    color: [
      {
        hexa: "#FDE8E8",
        alpha: "100"
      },
      {
        hexa: "#F8BABA",
        alpha: "100"
      },
      {
        hexa: "#F38B8B",
        alpha: "100"
      },
      {
        hexa: "#EE5D5D",
        alpha: "100"
      },
      {
        hexa: "#E61717",
        alpha: "100"
      }
    ]
  },
  {
    id: "red_blue",
    name: "dbl_chart_condition_color_red_blue",
    color: [
      {
        hexa: "#F5222D",
        alpha: "100"
      },
      {
        hexa: "#FA868C",
        alpha: "100"
      },
      {
        hexa: "#FEF8F8",
        alpha: "100"
      },
      {
        hexa: "#A2D2FF",
        alpha: "100"
      },
      {
        hexa: "#319CFF",
        alpha: "100"
      }
    ]
  },
  {
    id: "green_purple",
    name: "dbl_chart_condition_color_green_purple",
    color: [
      {
        hexa: "#BAEC94",
        alpha: "100"
      },
      {
        hexa: "#DEF6CD",
        alpha: "100"
      },
      {
        hexa: "#FEF8F8",
        alpha: "100"
      },
      {
        hexa: "#CFB3F0",
        alpha: "100"
      },
      {
        hexa: "#9458DF",
        alpha: "100"
      }
    ]
  },
  {
    id: "blue_cyan",
    name: "dbl_chart_condition_color_blue_cyan",
    color: [
      {
        hexa: "#3A9BDC",
        alpha: "100"
      },
      {
        hexa: "#9BCCEE",
        alpha: "100"
      },
      {
        hexa: "#FEF8F8",
        alpha: "100"
      },
      {
        hexa: "#A2E8C0",
        alpha: "100"
      },
      {
        hexa: "#36CE76",
        alpha: "100"
      }
    ]
  },
  {
    id: "orange_red",
    name: "dbl_chart_condition_color_orange_red",
    color: [
      {
        hexa: "#FFA80A",
        alpha: "100"
      },
      {
        hexa: "#FFD993",
        alpha: "100"
      },
      {
        hexa: "#FEF8F8",
        alpha: "100"
      },
      {
        hexa: "#FFB4A4",
        alpha: "100"
      },
      {
        hexa: "#FF5A36",
        alpha: "100"
      }
    ]
  },
  {
    id: "purple_pink",
    name: "dbl_chart_condition_color_purple_pink",
    color: [
      {
        hexa: "#A469BD",
        alpha: "100"
      },
      {
        hexa: "#9F60B978",
        alpha: "100"
      },
      {
        hexa: "#FEF8F8",
        alpha: "100"
      },
      {
        hexa: "#F59BB9",
        alpha: "100"
      },
      {
        hexa: "#EA2266",
        alpha: "100"
      }
    ]
  }
];

export const CUSTOM_LIST = [
  {
    id: "custom",
    name: "dbl_chart_map_color_custom",
    color: [
      {
        hexa: '#F2F3F5',
        alpha: '100',
      },
      {
        hexa: '#F2F3F5',
        alpha: '100',
      },
      {
        hexa: '#F2F3F5',
        alpha: '100',
      },
      {
        hexa: '#F2F3F5',
        alpha: '100',
      },
      {
        hexa: '#F2F3F5',
        alpha: '100',
      }
    ]
  }
];